module.exports = __webpack_public_path__ + "static/media/origin_marker_icon.14fdeaed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/viaVan/images/origin_marker_icon.svg
// module id = 503
// module chunks = 0